<div fxLayout="column" fxLayoutAlign="start center" class="pr-24 pl-24 pb-48 pt-48 w-100 h-100">
    <div class="h3-semi-bold c-primary-gray-900 text-center pre-line">
        {{ 'i18n_af_exportFraudDialogTitleExportList' | translate }}
    </div>
    @if (Spinner.isShown('exporting')) {
        <div class="mt-16 t3 c-primary-gray-600 text-center pre-line">
            {{ 'i18n_af_exportFraudDialogTitleGenerationInProgress' | translate }}
        </div>
    }
    @if (form) {
        <form [formGroup]="form" fxLayout="column" fxLayoutAlign="start center" class="w-100 h-100 min-max-w-400"
              (submit)="exportFraudList()">
            @if (!Spinner.isShown('exporting') && dialogData.exportMode === 'subjects') {
                @if (form.controls.dateRangeForm) {
                    <af-date-range-picker-field
                        class="w-100"
                        fxFlex
                        [form]="form.controls.dateRangeForm"
                        [shouldValidateRange]="true"
                        (openPickerListener)="initDateRangeField()"
                        label="i18n_af_labelRange"/>
                    @if (form.controls.dateRangeForm.hasError('invalidMaxDateRange')) {
                        <mat-error
                            class="t4 c-secondary-red-800">{{ 'i18n_af_fieldValidationExportMaxDateRange' | translate }}
                        </mat-error>
                    }
                }
                @if (form.controls.subjectTypeMultiple) {
                    <div [formGroupName]="'subjectTypeMultiple'" fxLayout="column" fxLayoutAlign="start stretch"
                         class="w-100 h-100 mt-24 filter-container">
                        <div class="t5 c-primary-gray-600 mb-4">{{ 'i18n_af_labelSubjectType' | translate }}</div>
                        <div fxLayout="column" fxLayoutAlign="start" class="w-100 h-100 filter-items-container">
                            @for (value of subjectTypes; track value) {
                                <div>
                                    <ui-kit-checkbox appearance="small" [formControlName]="$any(value)?.code || value">
                                        {{ ('i18n_af_subjectType#' + value?.code) | translate }}
                                    </ui-kit-checkbox>
                                </div>
                            }
                        </div>
                    </div>
                }
                @if (form.controls.categoryMultiple) {
                    <div [formGroupName]="'categoryMultiple'" fxLayout="column" fxLayoutAlign="start stretch"
                         class="w-100 h-100 mt-24 filter-container">
                        <div class="t5 c-primary-gray-600 mb-4">
                            {{ 'i18n_af_labelCategory' | translate }}
                            <span class="c-primary-green-800 ml-4" [fxHide]="selectedValueCount('categoryMultiple') === 0"> (Выбрано: {{ selectedValueCount('categoryMultiple') }})</span>
                        </div>
                        <div fxLayout="column" fxLayoutAlign="start" class="w-100 h-100 filter-items-container">
                            @for (value of categories; track value) {
                                <div>
                                    <ui-kit-checkbox appearance="small" [formControlName]="$any(value)?.code || value">
                                        {{ $any(value).name_ru | translate }}
                                    </ui-kit-checkbox>
                                </div>
                            }
                        </div>
                    </div>
                }
                @if (form.controls.subjectStatusMultiple) {
                    <div [formGroupName]="'subjectStatusMultiple'" fxLayout="column" fxLayoutAlign="start stretch"
                         class="w-100 h-100 mt-24 filter-container">
                        <div class="t5 c-primary-gray-600 mb-4">{{ 'i18n_af_labelStatus' | translate }}</div>
                        <div fxLayout="column" fxLayoutAlign="start" class="w-100 h-100 filter-items-container">
                            @for (value of subjectStatuses; track value) {
                                <div>
                                    <ui-kit-checkbox appearance="small" [formControlName]="$any(value)?.code || value">
                                        {{ $any(value).name_ru | translate }}
                                    </ui-kit-checkbox>
                                </div>
                            }
                        </div>
                    </div>
                }
            }
            @if (!Spinner.isShown('exporting') && dialogData.exportMode === 'loans') {
                @if (form.controls.organizations) {
                    <af-dictionary-selector
                        class="w-100 mt-24"
                        dictionaryName="bin"
                        selectedCountPlaceholder="i18n_af_placeholderOrganizationSelectedCount"
                        [isMultiple]="true"
                        [control]="form.controls.organizations"
                        [shouldAddSelectAll]="!isLoanRestricted"
                        [filterDictionaryBy]="isLoanRestricted ? [organizationBin] : null"
                        label="i18n_af_labelOrganizations"
                        placeholder="i18n_af_placeholderOrganizations"/>
                }
            }
            <ui-kit-button [label]="'i18n_af_buttonExport' | translate"
                           class="mt-32"
                           [disabled]="form.invalid"
                           spinnerId="exporting"/>
            <ui-kit-button [label]="'i18n_af_buttonCancel' | translate"
                           class="mt-16"
                           buttonType="button"
                           type="text"
                           (clickListener)="dialogRef.close()"/>
        </form>
    }
</div>
